module.exports = __webpack_public_path__ + "img/gr.f796b4cb.svg";